import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';

const partnersSlider = () => {
    // Pricing table - mobile only slider
    let init = false;
    let pricingCardSwiper: Swiper | null = null;

    const swiperCard = () => {
        if (window.innerWidth <= 767) {
            if (!init) {
                init = true;
                pricingCardSwiper = new Swiper('.swiper-container-partners', {
                    modules: [Autoplay],
                    slidesPerView: 'auto',
                    spaceBetween: 0,
                    grabCursor: true,
                    keyboard: true,
                    direction: 'horizontal',
                    autoplay: {
                        delay: 0,
                        // pauseOnMouseEnter:true,
                        disableOnInteraction:false,
                    },
                    speed: 5000,
                    loop: true,
                    breakpoints: {
                        768: {
                            slidesPerView: 2,
                        },
                    },
                });
            }
        } else if (init && pricingCardSwiper) {
            pricingCardSwiper.destroy();
            init = false;
        }

    }

    swiperCard();
    window.addEventListener("resize", swiperCard);
};

export { partnersSlider as default };
